// eslint-disable-next-line import/no-anonymous-default-export
import { clientId } from "./constants/okta";
import { OAuthResponseType } from '@okta/okta-auth-js';

export const oktaconfig = {
  oidc: {
    issuer: process.env.REACT_APP_OKTA_ISSUER!,
    clientId: clientId,
    pkce: true,
    scopes: ['openid', 'profile', 'email', 'offline_access'],
    redirectUri: `${window.location.origin}/login/callback`, // Changed from /implicit/callback
    responseType: 'code' as OAuthResponseType,
    services: {
      autoRenew: true,
      expireEarlySeconds: 5 * 60
    },
    tokenManager: {
      autoRenew: true,
      expireEarlySeconds: 5 * 60
    }
  },
  widget: {
    baseUrl: 'https://myarc.oktapreview.com/',
    clientId: clientId,
    pkce: true,
    useClassicEngine: true,
    redirectUri: `${window.location.origin}/login/callback`,
    logo: 'https://www2.arccorp.com/globalassets/arc-logos/corporate-logos/arc-logo-l-teal.png',
    authParams: {
      issuer: process.env.REACT_APP_OKTA_ISSUER!,
      scopes: ['openid', 'profile', 'email', 'offline_access'],
      services:{
        autoRenew: true,
        expireEarlySeconds: 5 * 60
      },
      tokenManager:{
        autoRenew: true,
        expireEarlySeconds: 5 * 60
      }
    }
  }
};